module.exports = __webpack_public_path__ + "assets/img/register_success.e26059ad.svg";